import { MUTATIONS_KEYS } from '../../store';
import { createWires } from '../wiring.util';
import { WIRE_FACTORY } from './wires.factory';

export const CONFIG_WIRES = createWires({
  setDynamicConfig: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.config.setDynamicConfig)
});
